import { useState, useEffect } from 'react'
import styled from 'styled-components'
import SavedSearchIcon from '@mui/icons-material/SavedSearch'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import IconButton from '@mui/material/IconButton'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { Badge as UnstyledBadge, Tooltip as UnstyledTooltip } from '@mui/material'
import { useQueryClient } from 'react-query'

import { getIsAuthorized } from '../core/AccountProvider'
import navigate from '../core/navigate'
import { useAccountQuery, useNewItemsQuery, useSavedSearchesQuery } from '../core/queries'

const Wrapper = styled.div`
  margin: -5px 5px 5px 0px;
  display: inline-block;
  text-align: right;
`

const Badge = styled(UnstyledBadge)`
  & .MuiBadge-badge {
    color: white;
    font-size: 11px;
    font-weight: bold;
  }
`

const Tooltip = props => {
  return (
    <UnstyledTooltip
      // PopperProps={{
      //   modifiers: [
      //     {
      //       name: "offset",
      //       options: {
      //         offset: [0, -14],
      //       },
      //     },
      //   ],
      // }}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            marginTop: '6px !important',
            padding: '4px 8px',
            fontSize: '11px',
            lineHeight: '18px'
          }
        }
      }}
      {...props}
    />
  )
}

export default () => {
  const isAuthorized = getIsAuthorized()
  const client = useQueryClient()

  const { data: accountData, isLoading: isAccountLoading } = useAccountQuery()
  const { data: newItemsData } = useNewItemsQuery(accountData.lastLoginTime, !isAccountLoading)
  const [newMatchesCount, setNewMatchesCount] = useState(0)

  useSavedSearchesQuery(data => {
    setNewMatchesCount(
      data.data.reduce((acc, savedsearch) => {
        return acc + savedsearch.newMatches
      }, 0)
    )
  })

  const handleRecommendations = () => {
    if (isAuthorized) navigate(`/search/recommendations`)
    else navigate('/account/login?return=/search/recommendations&feature')
  }

  const handleSavedSearches = () => {
    if (isAuthorized) navigate(`/account/savedsearches`)
    else navigate('/account/login?return=/account/savedsearches&feature')
  }

  const handleNewItems = () => {
    const lastLoginTime = new Date(accountData.lastLoginTime).getTime().toString().substring(0, 10)

    navigate(
      `/search?isOnSaleOrder=false&sortBy=date_created-desc&timestamp=${lastLoginTime}&newitems=true`
    )
  }

  useEffect(() => {
    window.addEventListener('route', () => {
      client.invalidateQueries('savedsearches')
    })
  }, [])

  return (
    <Wrapper>
      <Tooltip title='Recommendations'>
        <IconButton
          id='notifications_recommendations'
          color='secondary'
          component='button'
          onClick={handleRecommendations}
          sx={{ marginRight: '5px' }}>
          <Badge color='danger' badgeContent={10} invisible={!isAuthorized}>
            <BookmarkIcon sx={{ color: '#06642f', fontSize: '24px' }} />
          </Badge>
        </IconButton>
      </Tooltip>
      {newItemsData.length > 0 && isAuthorized && (
        <Tooltip title='New items'>
          <IconButton
            id='notifications_new_items'
            color='secondary'
            component='button'
            onClick={handleNewItems}
            sx={{ marginRight: '5px' }}>
            <Badge color='danger' badgeContent={newItemsData.length} invisible={!isAuthorized}>
              <NotificationsIcon sx={{ color: 'purple.main', fontSize: '24px' }} />
            </Badge>
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title='Saved searches'>
        <IconButton
          id='notifications_new_matches'
          color='secondary'
          component='button'
          onClick={handleSavedSearches}>
          <Badge color='danger' badgeContent={newMatchesCount} invisible={!isAuthorized}>
            <SavedSearchIcon sx={{ color: 'purple.main', fontSize: '24px' }} />
          </Badge>
        </IconButton>
      </Tooltip>
    </Wrapper>
  )
}
